import { render, staticRenderFns } from "./TotalListRowMeal.vue?vue&type=template&id=6113201a&"
import script from "./TotalListRowMeal.vue?vue&type=script&lang=js&"
export * from "./TotalListRowMeal.vue?vue&type=script&lang=js&"
import style0 from "./TotalListRowMeal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports